export default "__VITE_ASSET__DHFW4CmP__"